import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class UiService {
  private sidebarOpenSubject = new BehaviorSubject<boolean>(false);
  sidebarOpen$ = this.sidebarOpenSubject.asObservable();

  toggleSidebar(open?: boolean): void {
    if (typeof open === 'boolean') this.sidebarOpenSubject.next(open);
    else this.sidebarOpenSubject.next(!this.sidebarOpenSubject.value);
  }
}
